module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_invoice_white-0ebbac98e4ed587cbde5278e5c29fdfc.png";